import { WorkLogPage } from "../../../model/work-log/WorkLogPage/WorkLogPage";

export const FN40S37DocumentWorkLog = () => {
  return <WorkLogPage type={"document"} />;
};
